// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3gbGB","title":"styles_title__1zPY5"};